import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const { BASE_API, BASE_XHH } = extractAPIValues()

// 检测是否拥有屏幕共享能力并获取配置列表
export function checkScreenShare (args) {
	let url = BASE_API + '/chatroom/v2/screen_share/check'
	return axiosGetHandler(url, args)
}

// 屏幕分享-任务
export function getScreenShareTask (args) {
	let url = BASE_API + '/chatroom/v2/task/screen_share'
	return axiosGetHandler(url, args)
}

// 开始屏幕共享
export function startScreenShare (args, formdata) {
	let url = BASE_API + '/chatroom/v2/screen_share/start'
	return axiosPostHandler(url, args, formdata)
}

// 更新屏幕共享
export function updateScreenShare (args, formdata) {
	let url = BASE_API + '/chatroom/v2/screen_share/update'
	return axiosPostHandler(url, args, formdata)
}

// 结束屏幕共享
export function endScreenShare (args, formdata) {
	let url = BASE_API + '/chatroom/v2/screen_share/end'
	return axiosPostHandler(url, args, formdata)
}

// 获取屏幕共享套餐支付token
export function getPayScreenToken (args) {
	let url = BASE_XHH + '/pay/heychat_pay/'
	return axiosGetHandler(url, args)
}

// 周期共享套餐支付pay_url
export function getCyclePayScreenToken (args) {
	let url = BASE_XHH + '/pay/ali_cycle_pay/'
	return axiosGetHandler(url, args)
}

// 轮询屏幕共享套餐支付状态
export function checkPayScreenStatus (args) {
	let url = BASE_XHH + '/pay/heychat_pay_result_query/'
	return axiosGetHandler(url, args)
}

export function getScreenShareGoods (args) {
	let url = BASE_API + '/chatroom/v2/screen_share/goods'
	return axiosGetHandler(url, args)
}

export function getPayScreenHistory (args) {
	let url = BASE_API + '/chatroom/v2/screen_share/pay/log'
	return axiosGetHandler(url, args)
}

// 检查是否可以赠送屏幕共享
export function checkCanPresentGift(args) {
	let url = BASE_API + '/chatroom/v2/screen_share/gift/check'
	return axiosGetHandler(url, args)
}

// 接收或者拒绝屏幕共享礼物
export function acceptOrRejectScreenGift(args, formdata) {
    let url = BASE_API + '/chatroom/v2/screen_share/gift/accept'
	return axiosPostHandler(url, args, formdata)
}